import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import api from "../lib/api";
import { useAuth } from "../context/AuthContext";
import { Button } from "../components/ui/button";
import { BookOpen, Lock, FileText, Crown } from "lucide-react";

export default function Workbook() {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [items, setItems] = useState([]);

  useEffect(() => { api.get("/workbook").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <Layout>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8">
        <div className="flex items-center gap-3 mb-2">
          <BookOpen className="h-7 w-7 text-amber-600" />
          <h1 className="font-heading text-2xl sm:text-3xl font-bold text-[#0A192F]">California Property &amp; Casualty</h1>
        </div>
        <p className="text-slate-500 mb-8">Course chapters — open any chapter to continue studying.</p>

        {!user?.has_full_access && (
          <div className="rounded-xl bg-amber-50 border border-amber-200 p-4 mb-6 flex items-center justify-between gap-3" data-testid="workbook-upgrade-banner">
            <span className="text-sm text-amber-800">You're viewing the free sample. Unlock every chapter with Full Access.</span>
            <Button size="sm" className="bg-amber-600 hover:bg-amber-700 text-white shrink-0" onClick={() => navigate("/upgrade")}><Crown className="h-4 w-4 mr-1" /> $49.95</Button>
          </div>
        )}

        <div className="space-y-3" data-testid="workbook-list">
          {items.map((it) => (
            <div key={it.id} className={`rounded-xl border p-4 flex items-center justify-between gap-3 ${it.locked ? "border-slate-200 bg-slate-50" : "border-slate-200 bg-white hover:border-amber-300 hover:shadow-md transition"}`} data-testid={`workbook-item-${it.id}`}>
              <div className="flex items-center gap-3 min-w-0">
                <div className={`h-10 w-10 rounded-lg flex items-center justify-center shrink-0 ${it.locked ? "bg-slate-200" : "bg-[#0A192F]"}`}>
                  {it.locked ? <Lock className="h-5 w-5 text-slate-500" /> : <FileText className="h-5 w-5 text-amber-500" />}
                </div>
                <div className="min-w-0">
                  <div className="font-medium text-[#0A192F] truncate">{it.title}</div>
                  {it.is_sample && <span className="text-xs text-emerald-600 font-semibold">FREE SAMPLE</span>}
                </div>
              </div>
              {it.locked ? (
                <Button size="sm" variant="outline" className="shrink-0" onClick={() => navigate("/upgrade")} data-testid={`workbook-unlock-${it.id}`}>Unlock</Button>
              ) : (
                <Link to={`/workbook/${it.id}`}><Button size="sm" className="bg-[#0A192F] hover:bg-[#1E293B] text-white shrink-0" data-testid={`workbook-read-${it.id}`}>Read</Button></Link>
              )}
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
